import type { FormContext, FormField, StepContext } from '../types'
import { TrackingEvent } from '../types'

export interface FormContinuedArgs {
  formContext: FormContext
  stepContext: StepContext
  field: FormField[]
}

export interface FormContinuedProperties {
  formContext: FormContext
  stepContext: StepContext
  field: FormField[]
}

export class FormContinued extends TrackingEvent {
  properties: FormContinuedProperties

  constructor(args: FormContinuedArgs) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formVersion: '',
        formId: '',
      },
      stepContext = {
        stepId: '',
        stepName: '',
        stepNumber: 0,
      },
      field = [],
    } = args ?? {}

    super('FormContinued', 'redventures.usertracking.v3.FormContinued')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formVersion: formContext.formVersion,
        formId: formContext.formId,
      },
      stepContext: {
        stepId: stepContext.stepId,
        stepName: stepContext.stepName,
        stepNumber: stepContext.stepNumber,
      },
      field: field,
    }
  }
}
